export const SELECTION_KEY = 'account-page-groups';
export const PLACE = 'Account Groups Table';

export const COLUMNS = {
    GROUP_NAME: 'groupName',
    MEMBERS: 'members',
    GROUP_OWNER: 'groupOwner',
    NOTES: 'notes',
    LAST_UPDATE: 'lastUpdateDate',
};
export const HEADERS = {
    [COLUMNS.GROUP_NAME]: 'Group Name',
    [COLUMNS.MEMBERS]: 'Members',
    [COLUMNS.GROUP_OWNER]: 'Group Owner',
    [COLUMNS.NOTES]: 'Notes',
    [COLUMNS.LAST_UPDATE]: 'Last Update',
};

export const COLUMNS_DATA = [
    {
        columnId: COLUMNS.GROUP_NAME,
        fixed: true,
        minWidth: 324,
        maxWidth: 520,
        defaultWidth: 424,
    },
    {
        columnId: COLUMNS.MEMBERS,
        fixed: false,
        minWidth: 180,
        defaultWidth: 200,
        maxWidth: 250,
    },
    {
        columnId: COLUMNS.GROUP_OWNER,
        fixed: false,
        minWidth: 200,
        defaultWidth: 300,
        maxWidth: 350,
    },
    {
        columnId: COLUMNS.NOTES,
        fixed: false,
        minWidth: 500,
        defaultWidth: 700,
        maxWidth: 1100,
    },
    {
        columnId: COLUMNS.LAST_UPDATE,
        fixed: false,
        minWidth: 180,
        defaultWidth: 200,
        maxWidth: 300,
    },
];

export const MAX_GROUP_NAME_LENGTH = 50;

export const GROUP_TABS = {
    SETTINGS: {
        name: 'settings',
        caption: 'Group Settings',
    },
    MEMBERS: {
        name: 'members',
        caption: 'Group Members',
    },
};
